import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { isAuthenticated, isAdmin, user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo-link">
          <img src="/Logo Trimmed.png" alt="SilverScribe" className="navbar-logo" />
        </Link>
        <div className="navbar-menu">
          <Link to={isAuthenticated ? '/dashboard' : '/'} className="navbar-home-btn">
            Home
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
